import React, { useState } from 'react';

import { useFlashMessages } from '../../contexts/FlashMessages';
import { useTranslation } from 'react-i18next';
import { FlashMessage } from './FlashMessage';

export default function FlashMessageListing() {
  const { flashMessages } = useFlashMessages();
  const { t } = useTranslation();

  return (
    <div className="fixed-top" >
      { flashMessages.map((flashMessage) => {
        return (
          <FlashMessage key={flashMessage.key} variant={flashMessage.variant} onClose={() => flashMessage.onClose(flashMessage)}>
            {flashMessage.text}
          </FlashMessage>
        );
      })}
    </div>
  );
}
